import { createContext, useContext, useState, useEffect } from 'react';
import Api from '../utils/Api';

const BackgroundContext = createContext();

// logique du provider rédigée avec une assistance IA
// charge le fond de l'utilisateur au démarrage et le rend accessible sur toutes les pages
export function BackgroundContextProvider({ children }) {
    const [backgroundUrl, setBackgroundUrl] = useState(null);

    useEffect(() => {
        Api.get('/auth/current_user')
            .then((response) => {
                if (response.data.backgroundImagePath) {
                    setBackgroundUrl(response.data.backgroundImagePath);
                }
            })
            .catch(() => {});
    }, []);

    return (
        <BackgroundContext.Provider value={{ backgroundUrl, setBackgroundUrl }}>
            {children}
        </BackgroundContext.Provider>
    );
}

export function useBackground() {
    return useContext(BackgroundContext);
}
